// Uploaded files are addressed by their attachment's ID and name, written as a
// key "<attachment id>/<name>", because names aren't unique. The work
// instruction fields that point at one file, pdfPath and preview_img, hold
// such a key. The default preview image is the only file addressed by its
// name alone.

export const DEFAULT_PREVIEW_IMAGE = "default-wi-preview-img.jpg";

// The key of an attachment record, which has _id and path (its name).
export const fileKey = (attachment) => `${attachment._id}/${attachment.path}`;

// The API path that serves the file with this key.
export const fileApiPath = (key) =>
    `/api/attachments/${String(key).split("/").map(encodeURIComponent).join("/")}`;

// The URL that serves the file with this key.
export const fileUrl = (key) => `${window.config.getApiBaseUrl()}${fileApiPath(key)}`;

// The file's name, for showing it or saving it.
export const fileName = (key) => String(key).split("/").pop();

// The attachment ID in a key, or undefined for a file addressed by name alone.
export const fileId = (key) => (String(key).includes("/") ? String(key).split("/")[0] : undefined);

// The URL of a feedback picture, which has its own _id and path.
export const feedbackFileUrl = (attachment) =>
    `${window.config.getApiBaseUrl()}/api/feedback/attachments/${attachment._id}/${encodeURIComponent(attachment.path)}`;
